import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import styles from './index.module.scss'
import API, { commonApiInvoker } from '@api/api'
import { Button, Divider, Empty, Image, Input, message, Select, Space, Spin, Checkbox, Radio } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import InfiniteScroll from 'react-infinite-scroll-component'
import Utils from "@utils/utils"
import ImagePreviewWithLabel from '@view/compoents/ImagePreviewWithLabel';
import eventBus from '@utils/eventBus';
import { useLocation } from 'react-router-dom'
import { flushSync } from 'react-dom'
import PSAIModal from "@PSAIComponents/PSAIModal";
import JSZip from 'jszip'
import axios from 'axios'
import { saveAs } from "file-saver";

const DeliveryImageItem = ({item, onPreview}) => {
    const isVideo = useMemo(() => {
        return /\.mp4/.test(item.url)
    }, [item])
    return (
        <div
            className={styles.DeliveryImageItem}
            style={{width: 120, height: 160}}
            onClick={() => {
                onPreview({
                    imageId: item.imageId,
                    skuId: item.skuCode || item.skuNumber, // 没填商品货号，使用skuNumber作为skuid
                })
            }}
        >
        {
            isVideo ?
            <Image
                rootClassName={styles.ImageItem}
                style={{cursor:"pointer"}}
                src={Utils.getVideoSnapshot(item.url)}
                alt="sku"
                fallback={require('@assets/images/fallback.png')}
                preview={false}
            /> :
            <Image
                rootClassName={styles.ImageItem}
                style={{cursor:"pointer"}}
                src={Utils.getImgThumbnail(item.url)}
                alt="sku"
                fallback={require('@assets/images/fallback.png')}
                preview={false}
            />
        } {
            item.status == 2 && item.isDownload ? <span className={`${styles.Status} ${styles.Downloaded}`}>已下载</span> :
            item.status == 2 && !item.isDownload ? <span className={`${styles.Status} ${styles.Passed}`}>已通过</span> :
            item.status == 3 ? <span className={`${styles.Status} ${styles.FineTuning}`}>不通过</span> :
            item.status == -1 ? <span className={`${styles.Status} ${styles.Canceled}`}>已取消</span> :
            item.refine ? <span className={`${styles.Status} ${styles.FineTuned}`}>待复验</span> : 
            <span className={`${styles.Status} ${styles.WaitCheck}`}>待验收</span>
        }
        </div>
    )
}

export default DeliveryImageItem
